import { render, staticRenderFns } from "./ContributorList.vue?vue&type=template&id=af291322&scoped=true"
import script from "./ContributorList.vue?vue&type=script&lang=js"
export * from "./ContributorList.vue?vue&type=script&lang=js"
import style0 from "./ContributorList.vue?vue&type=style&index=0&id=af291322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af291322",
  null
  
)

export default component.exports